import React, { useMemo } from 'react';
import { Tooth, ToothFurcation } from '../../../../graphql/graphql';
import { ToothView } from '../../Enums/ToothView.enum';
import { getIconHeightPosition } from '../../Helpers/periodontal/iconHeightPosition';

interface Props {
	tooth?: Tooth;
	width: number;
	height: number;
	view: ToothView;
}

const DENTToothFurcation = ({ tooth, width, height, view }: Props) => {
	if (
		!tooth?.periodontal?.furcation ||
		tooth?.periodontal?.furcation === ToothFurcation.None
	) {
		return <></>;
	}

	const svgContent = useMemo(() => {
		switch (tooth.periodontal?.furcation) {
			case ToothFurcation.Stage_1:
				return (
					<polyline
						points='10,90 50,10 90,90'
						fill='none'
						stroke='black'
						stroke-width='12'
					/>
				);
			case ToothFurcation.Stage_2:
				return (
					<polygon
						points='50,10 90,90 10,90'
						fill='none'
						stroke='black'
						stroke-width='12'
					/>
				);
			case ToothFurcation.Stage_3:
				return <polygon points='50,10 90,90 10,90' fill='black' />;
			default:
				return null;
		}
	}, [tooth.periodontal?.furcation]);

	const furcationWidth = useMemo(() => width / 2 - 25, [width]);
	const furcationHeight = useMemo(
		() =>
			getIconHeightPosition({
				height,
				view,
				jaw: tooth.jaw,
				crownUpOffset: 0.55,
				crownDownOffset: 0.45,
			}),
		[height, view, tooth.jaw],
	);

	return (
		<g transform={`translate(${furcationWidth},${furcationHeight})`}>
			<svg width='50' height='50' viewBox='0 0 100 100'>
				{svgContent}
			</svg>
		</g>
	);
};

export default DENTToothFurcation;
